import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './use-auth';

export interface UserCompany {
  company_id: string;
  companies: {
    name: string;
  } | null;
}

export function useUserCompanies() {
  const { profile } = useAuth();

  return useQuery({
    queryKey: ['user-companies', profile?.id],
    queryFn: async () => {
      if (!profile?.id) {
        console.log('📋 useUserCompanies: No profile ID available');
        return [];
      }

      console.log('📋 useUserCompanies: Fetching companies for user:', profile.id);

      const { data, error } = await supabase
        .from('user_companies')
        .select('company_id, companies(name)')
        .eq('user_id', profile.id);

      if (error) {
        console.error('❌ useUserCompanies: Error fetching companies:', error);
        throw error;
      }

      console.log('✅ useUserCompanies: Found companies:', data?.length || 0, data);
      return (data || []) as UserCompany[];
    },
    enabled: !!profile?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
